import React, { createContext, useContext, useEffect, useState } from "react";
import { api, formatError } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading
  const [error, setError] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/auth/me");
        setUser(data);
      } catch (e) {
        // Anonymous / expired session — treat as logged out, log for dev only.
        if (process.env.NODE_ENV !== "production") console.debug("auth/me:", e?.response?.status || e);
        setUser(false);
      }
    })();
  }, []);

  async function login(identifier, password) {
    setError("");
    try {
      const { data } = await api.post("/auth/login", { identifier, password });
      setUser(data);
      return true;
    } catch (e) {
      setError(formatError(e));
      return false;
    }
  }

  async function logout() {
    try { await api.post("/auth/logout"); } catch (e) { if (process.env.NODE_ENV !== "production") console.debug("logout:", e); }
    setUser(false);
  }

  return (
    <AuthCtx.Provider value={{ user, setUser, login, logout, error, setError }}>
      {children}
    </AuthCtx.Provider>
  );
}

export function useAuth() {
  return useContext(AuthCtx);
}
